/* Exact editable text geometry and isolated fixed artwork from NK-117-129.psd. */
DESIGN_TEMPLATES.push(...[
  {
    "key": "nk117",
    "sku": "NK-117",
    "name": "Double Initials",
    "category": "wedding",
    "description": "Double Initials. Original PSD layout; personalize the text.",
    "canvasSize": 1476,
    "version": "psd1476-20261101",
    "thumbnail": "mr-nk117-white-v2.webp",
    "fixedTexture": "mr-fixed-117-v2.webp",
    "fields": [
      {
        "key": "initial1",
        "label": "First initial",
        "value": "C",
        "prefix": "",
        "font": "Big Caslon",
        "fontFile": "BigCaslon-Web.ttf",
        "fontPostScript": "BigCaslon-Medium",
        "size": 300.0,
        "transform": [
          0.44006299961427103,
          0.0,
          0.0,
          0.44010324126620615,
          461.1852736092634,
          624.0238510688663
        ],
        "bbox": [
          464.94,
          526.932,
          557.928,
          625.086
        ],
        "align": "left",
        "tracking": 50.0,
        "caps": 0,
        "maxWidth": 125.53,
        "maxLength": 1
      },
      {
        "key": "initial2",
        "label": "Second initial",
        "value": "H",
        "prefix": "",
        "font": "Big Caslon",
        "fontFile": "BigCaslon-Web.ttf",
        "fontPostScript": "BigCaslon-Medium",
        "size": 300.0,
        "transform": [
          0.44006299961427103,
          0.0,
          0.0,
          0.44010324126620615,
          603.4038458270892,
          770.2075737451736
        ],
        "bbox": [
          608.85,
          675.27,
          716.598,
          770.472
        ],
        "align": "left",
        "tracking": 50.0,
        "caps": 0,
        "maxWidth": 145.46,
        "maxLength": 1
      }
    ],
    "fixedText": [],
    "staticLayers": [
      {
        "key": "fixed1",
        "label": "&",
        "asset": "mr-layer-117-1-v2.webp",
        "bbox": [
          535.05,
          603.684,
          632.466,
          709.218
        ]
      }
    ]
  },
  {
    "key": "nk118",
    "sku": "NK-118",
    "name": "Double Initials · Classic",
    "category": "wedding",
    "description": "Double Initials · Classic. Original PSD layout; personalize the text.",
    "canvasSize": 1476,
    "version": "psd1476-20261101",
    "thumbnail": "mr-nk118-white-v2.webp",
    "fixedTexture": "mr-fixed-118-v2.webp",
    "fields": [
      {
        "key": "initial1",
        "label": "First initial",
        "value": "A",
        "prefix": "",
        "font": "Big Caslon",
        "fontFile": "BigCaslon-Web.ttf",
        "fontPostScript": "BigCaslon-Medium",
        "size": 200.0,
        "transform": [
          0.728261202333463,
          0.0,
          0.0,
          0.7285239969124099,
          466.455673520499,
          593.0366785113752
        ],
        "bbox": [
          461.25,
          486.342,
          573.426,
          593.352
        ],
        "align": "left",
        "tracking": 50.0,
        "caps": 0,
        "maxWidth": 151.44,
        "maxLength": 1
      },
      {
        "key": "initial2",
        "label": "Second initial",
        "value": "K",
        "prefix": "",
        "font": "Big Caslon",
        "fontFile": "BigCaslon-Web.ttf",
        "fontPostScript": "BigCaslon-Medium",
        "size": 200.0,
        "transform": [
          0.728261202333463,
          0.0,
          0.0,
          0.7285239969124099,
          551.1102378605235,
          741.7811814671813
        ],
        "bbox": [
          557.1899999999999,
          636.894,
          668.628,
          741.6899999999999
        ],
        "align": "left",
        "tracking": 50.0,
        "caps": 0,
        "maxWidth": 150.44,
        "maxLength": 1
      }
    ],
    "fixedText": [],
    "staticLayers": [
      {
        "key": "fixed0",
        "label": "Divider",
        "asset": "mr-layer-118-0-v2.webp",
        "bbox": [
          466.416,
          519.552,
          656.082,
          702.576
        ]
      }
    ]
  },
  {
    "key": "nk119",
    "sku": "NK-119",
    "name": "Double Initials · Script",
    "category": "wedding",
    "description": "Double Initials · Script. Original PSD layout; personalize the text.",
    "canvasSize": 1476,
    "version": "psd1476-20261101",
    "thumbnail": "mr-nk119-white-v2.webp",
    "fixedTexture": "mr-fixed-119-v2.webp",
    "fields": [
      {
        "key": "initial1",
        "label": "First initial",
        "value": "K",
        "prefix": "",
        "font": "Beauty Queen",
        "fontFile": "BeautyQueen.otf",
        "fontPostScript": "BeautyQueenScript",
        "size": 400.0,
        "transform": [
          0.5360863535433694,
          0.0,
          0.0,
          0.536597421155286,
          462.96900079796893,
          629.8650371871104
        ],
        "bbox": [
          348.336,
          464.94,
          636.156,
          667.152
        ],
        "align": "center",
        "tracking": 0.0,
        "caps": 0,
        "maxWidth": 388.56,
        "maxLength": 1
      },
      {
        "key": "initial2",
        "label": "Second initial",
        "value": "L",
        "prefix": "",
        "font": "Beauty Queen",
        "fontFile": "BeautyQueen.otf",
        "fontPostScript": "BeautyQueenScript",
        "size": 400.0,
        "transform": [
          0.5360863535433694,
          0.0,
          0.0,
          0.536597421155286,
          592.5089884933939,
          793.7140561574198
        ],
        "bbox": [
          516.6,
          628.776,
          742.428,
          825.822
        ],
        "align": "center",
        "tracking": 80.0,
        "caps": 0,
        "maxWidth": 304.87,
        "maxLength": 1
      }
    ],
    "fixedText": [],
    "staticLayers": []
  },
  {
    "key": "nk120",
    "sku": "NK-120",
    "name": "Signature Initials & Names",
    "category": "wedding",
    "description": "Signature Initials & Names. Original PSD layout; personalize the text.",
    "canvasSize": 1476,
    "version": "psd1476-20261101",
    "thumbnail": "mr-nk120-white-v2.webp",
    "fixedTexture": "mr-fixed-120-v2.webp",
    "fields": [
      {
        "key": "initial1",
        "label": "First initial",
        "value": "T",
        "prefix": "",
        "font": "Signatrue",
        "fontFile": "Signatrue.ttf",
        "fontPostScript": "Signatrue",
        "size": 159.0,
        "transform": [
          0.7288818532818532,
          0.0,
          0.0,
          0.7288818532818532,
          452.92366744615146,
          535.083073360231
        ],
        "bbox": [
          371.214,
          376.38,
          733.572,
          611.802
        ],
        "align": "center",
        "tracking": 30.0,
        "caps": 0,
        "maxWidth": 489.18,
        "maxLength": 1
      },
      {
        "key": "initial2",
        "label": "Second initial",
        "value": "R",
        "prefix": "",
        "font": "Signatrue",
        "fontFile": "Signatrue.ttf",
        "fontPostScript": "Signatrue",
        "size": 149.0,
        "transform": [
          0.7288818532818532,
          0.0,
          0.0,
          0.7288818532818532,
          649.1659544400098,
          650.9804787199064
        ],
        "bbox": [
          477.486,
          493.722,
          794.826,
          749.808
        ],
        "align": "center",
        "tracking": 30.0,
        "caps": 0,
        "maxWidth": 428.41,
        "maxLength": 1
      },
      {
        "key": "name1",
        "label": "First name",
        "value": "Tason",
        "prefix": "",
        "font": "Bodoni Bk BT",
        "fontFile": "BodoniBT-Book.ttf",
        "fontPostScript": "BodoniBT-Book",
        "size": 60.0,
        "transform": [
          0.7288818532818532,
          0.0,
          0.0,
          0.7288818532818532,
          452.0744435927305,
          809.6994880643173
        ],
        "bbox": [
          387.45,
          780.066,
          515.124,
          810.324
        ],
        "align": "center",
        "tracking": 0.0,
        "caps": 2,
        "maxWidth": 172.36,
        "maxLength": 48
      },
      {
        "key": "name2",
        "label": "Second name",
        "value": "Rebecca",
        "prefix": "",
        "font": "Bodoni Bk BT",
        "fontFile": "BodoniBT-Book.ttf",
        "fontPostScript": "BodoniBT-Book",
        "size": 60.0,
        "transform": [
          0.7288818532818532,
          0.0,
          0.0,
          0.7288818532818532,
          674.3834088436959,
          809.6994880643173
        ],
        "bbox": [
          582.282,
          780.066,
          768.258,
          810.324
        ],
        "align": "center",
        "tracking": 0.0,
        "caps": 2,
        "maxWidth": 251.07,
        "maxLength": 48
      },
      {
        "key": "date",
        "label": "Date",
        "value": "09.12.2026",
        "prefix": "",
        "font": "Playfair Display",
        "fontFile": "PlayfairDisplay-Regular.ttf",
        "fontPostScript": "PlayfairDisplay-Regular",
        "size": 60.0,
        "transform": [
          0.7288818532818532,
          0.0,
          0.0,
          0.7288818532818532,
          566.8429426412276,
          872.5606304161142
        ],
        "bbox": [
          464.202,
          840.582,
          670.842,
          878.958
        ],
        "align": "center",
        "tracking": 30.0,
        "caps": 0,
        "maxWidth": 278.96,
        "maxLength": 48
      }
    ],
    "fixedText": [],
    "staticLayers": [
      {
        "key": "fixed3",
        "label": "&",
        "asset": "mr-layer-120-3-v2.webp",
        "bbox": [
          535.05,
          780.066,
          563.832,
          810.324
        ]
      }
    ]
  },
  {
    "key": "nk121",
    "sku": "NK-121",
    "name": "Couple Names",
    "category": "wedding",
    "description": "Couple Names. Original PSD layout; personalize the text.",
    "canvasSize": 1476,
    "version": "psd1476-20261101",
    "thumbnail": "mr-nk121-white-v2.webp",
    "fixedTexture": "mr-fixed-121-v2.webp",
    "fields": [
      {
        "key": "name1",
        "label": "First name",
        "value": "Melissa",
        "prefix": "",
        "font": "Tempting",
        "fontFile": "Tempting.ttf",
        "fontPostScript": "Tempting",
        "size": 150.0,
        "transform": [
          0.7288818532818532,
          0.0,
          0.0,
          0.7288818532818532,
          489.9497027418412,
          596.0074460004156
        ],
        "bbox": [
          278.964,
          471.582,
          712.17,
          611.064
        ],
        "align": "center",
        "tracking": 0.0,
        "caps": 0,
        "maxWidth": 584.83,
        "maxLength": 48
      },
      {
        "key": "name2",
        "label": "Second name",
        "value": "Joseph",
        "prefix": "",
        "font": "Tempting",
        "fontFile": "Tempting.ttf",
        "fontPostScript": "Tempting",
        "size": 150.0,
        "transform": [
          0.7288818532818532,
          0.0,
          0.0,
          0.7288818532818532,
          613.8596177997563,
          784.7878460004154
        ],
        "bbox": [
          425.826,
          659.7719999999999,
          812.538,
          836.8919999999999
        ],
        "align": "center",
        "tracking": 0.0,
        "caps": 0,
        "maxWidth": 522.06,
        "maxLength": 48
      },
      {
        "key": "date",
        "label": "Date",
        "value": "10.21.2026",
        "prefix": "",
        "font": "Big Caslon",
        "fontFile": "BigCaslon-Web.ttf",
        "fontPostScript": "BigCaslon-Medium",
        "size": 80.0,
        "transform": [
          0.7288818532818532,
          0.0,
          0.0,
          0.7288818532818532,
          685.1918272187858,
          878.7253620618412
        ],
        "bbox": [
          570.474,
          836.154,
          800.73,
          878.958
        ],
        "align": "center",
        "tracking": 0.0,
        "caps": 0,
        "maxWidth": 310.85,
        "maxLength": 48
      }
    ],
    "fixedText": [],
    "staticLayers": [
      {
        "key": "fixed3",
        "label": "&",
        "asset": "mr-layer-121-3-v2.webp",
        "bbox": [
          324.71999999999997,
          688.554,
          388.926,
          749.808
        ]
      }
    ]
  },
  {
    "key": "nk122",
    "sku": "NK-122",
    "name": "Couple Names · Handwritten",
    "category": "wedding",
    "description": "Couple Names · Handwritten. Original PSD layout; personalize the text.",
    "canvasSize": 1476,
    "version": "psd1476-20261101",
    "thumbnail": "mr-nk122-white-v2.webp",
    "fixedTexture": "mr-fixed-122-v2.webp",
    "fields": [
      {
        "key": "name1",
        "label": "First name",
        "value": "Mason",
        "prefix": "",
        "font": "Bradley Hand",
        "fontFile": "BradleyHand-Bold.ttf",
        "fontPostScript": "BradleyHandITCTT-Bold",
        "size": 71.46644,
        "transform": [
          1.3348372408047307,
          0.0,
          0.0,
          1.3348372408047304,
          341.3876865301934,
          693.271498940789
        ],
        "bbox": [
          199.26,
          642.798,
          487.08,
          697.41
        ],
        "align": "center",
        "tracking": 20.0,
        "caps": 0,
        "maxWidth": 388.56,
        "maxLength": 48
      },
      {
        "key": "name2",
        "label": "Second name",
        "value": "Catherine",
        "prefix": "   ",
        "font": "Bradley Hand",
        "fontFile": "BradleyHand-Bold.ttf",
        "fontPostScript": "BradleyHandITCTT-Bold",
        "size": 130.88,
        "transform": [
          0.7288818532818532,
          0.0,
          0.0,
          0.7288818532818532,
          769.0677022901194,
          690.7313810438891
        ],
        "bbox": [
          605.16,
          621.396,
          1014.012,
          696.672
        ],
        "align": "center",
        "tracking": 20.0,
        "caps": 0,
        "maxWidth": 551.95,
        "maxLength": 48
      },
      {
        "key": "date",
        "label": "Date",
        "value": "12.10.26",
        "prefix": "",
        "font": "Playfair Display",
        "fontFile": "PlayfairDisplay-Regular.ttf",
        "fontPostScript": "PlayfairDisplay-Regular",
        "size": 82.38734,
        "transform": [
          0.7288818532818532,
          0.0,
          0.0,
          0.7288818532818532,
          630.2556638767487,
          785.094808022292
        ],
        "bbox": [
          526.194,
          741.6899999999999,
          734.31,
          786.708
        ],
        "align": "center",
        "tracking": 30.0,
        "caps": 0,
        "maxWidth": 280.96,
        "maxLength": 48
      }
    ],
    "fixedText": [],
    "staticLayers": [
      {
        "key": "fixed2",
        "label": "&",
        "asset": "mr-layer-122-2-v2.webp",
        "bbox": [
          529.884,
          652.3919999999999,
          563.832,
          689.292
        ]
      }
    ]
  },
  {
    "key": "nk123",
    "sku": "NK-123",
    "name": "Couple Names · Script",
    "category": "wedding",
    "description": "Couple Names · Script. Original PSD layout; personalize the text.",
    "canvasSize": 1476,
    "version": "psd1476-20261101",
    "thumbnail": "mr-nk123-white-v2.webp",
    "fixedTexture": "mr-fixed-123-v2.webp",
    "fields": [
      {
        "key": "name1",
        "label": "First name",
        "value": "Belinda",
        "prefix": "",
        "font": "Buttering",
        "fontFile": "Buttering.otf",
        "fontPostScript": "Buttering",
        "size": 300.0,
        "transform": [
          0.7288818532818532,
          0.0,
          0.0,
          0.7288818532818532,
          599.8870182241707,
          557.4527850654614
        ],
        "bbox": [
          222.876,
          416.23199999999997,
          961.614,
          595.566
        ],
        "align": "center",
        "tracking": 0.0,
        "caps": 0,
        "maxWidth": 997.3,
        "maxLength": 48,
        "endAlternates": {
          "a": "",
          "b": "",
          "c": "",
          "d": "",
          "e": "",
          "f": "",
          "g": "",
          "h": "",
          "i": "",
          "j": "",
          "k": "",
          "l": "",
          "m": "",
          "n": "",
          "o": "",
          "p": "",
          "q": "",
          "r": "",
          "s": "",
          "t": "",
          "u": "",
          "v": "",
          "w": "",
          "x": "",
          "y": "",
          "z": ""
        }
      },
      {
        "key": "name2",
        "label": "Second name",
        "value": "Esther",
        "prefix": "",
        "font": "Buttering",
        "fontFile": "Buttering.otf",
        "fontPostScript": "Buttering",
        "size": 300.0,
        "transform": [
          0.7288818532818532,
          0.0,
          0.0,
          0.7288818532818532,
          707.596321148726,
          751.9967611585508
        ],
        "bbox": [
          450.18,
          610.326,
          964.566,
          806.634
        ],
        "align": "center",
        "tracking": 0.0,
        "caps": 0,
        "maxWidth": 694.42,
        "maxLength": 48,
        "endAlternates": {
          "a": "",
          "b": "",
          "c": "",
          "d": "",
          "e": "",
          "f": "",
          "g": "",
          "h": "",
          "i": "",
          "j": "",
          "k": "",
          "l": "",
          "m": "",
          "n": "",
          "o": "",
          "p": "",
          "q": "",
          "r": "",
          "s": "",
          "t": "",
          "u": "",
          "v": "",
          "w": "",
          "x": "",
          "y": "",
          "z": ""
        }
      },
      {
        "key": "date",
        "label": "Date",
        "value": "10.25.2026",
        "prefix": "",
        "font": "Playfair Display",
        "fontFile": "PlayfairDisplay-Regular.ttf",
        "fontPostScript": "PlayfairDisplay-Regular",
        "size": 80.0,
        "transform": [
          0.7288818532818532,
          0.0,
          0.0,
          0.7288818532818532,
          579.9034144674466,
          851.2115511610027
        ],
        "bbox": [
          452.394,
          808.11,
          707.004,
          859.77
        ],
        "align": "center",
        "tracking": 0.0,
        "caps": 0,
        "maxWidth": 343.72,
        "maxLength": 48
      }
    ],
    "fixedText": [],
    "staticLayers": [
      {
        "key": "fixed1",
        "label": "and",
        "asset": "mr-layer-123-1-v2.webp",
        "bbox": [
          245.016,
          645.012,
          383.022,
          703.314
        ]
      }
    ]
  },
  {
    "key": "nk124",
    "sku": "NK-124",
    "name": "Couple Names · Signature",
    "category": "wedding",
    "description": "Couple Names · Signature. Original PSD layout; personalize the text.",
    "canvasSize": 1476,
    "version": "psd1476-20261101",
    "thumbnail": "mr-nk124-white-v2.webp",
    "fixedTexture": "mr-fixed-124-v2.webp",
    "fields": [
      {
        "key": "name1",
        "label": "First name",
        "value": "Allen",
        "prefix": "",
        "font": "Sherlyn",
        "fontFile": "Sherlyn.otf",
        "fontPostScript": "Sherlyn",
        "size": 69.98103,
        "transform": [
          1.4581588086697805,
          0.0,
          0.0,
          1.4581588086697805,
          367.8047785593564,
          664.474520732385
        ],
        "bbox": [
          250.92,
          580.806,
          479.7,
          717.336
        ],
        "align": "center",
        "tracking": 30.0,
        "caps": 0,
        "maxWidth": 308.85,
        "maxLength": 48
      },
      {
        "key": "name2",
        "label": "Second name",
        "value": "Beatrice",
        "prefix": "  ",
        "font": "Sherlyn",
        "fontFile": "Sherlyn.otf",
        "fontPostScript": "Sherlyn",
        "size": 140.0,
        "transform": [
          0.7288818532818532,
          0.0,
          0.0,
          0.7288818532818532,
          692.1856924442701,
          659.7088252532518
        ],
        "bbox": [
          583.02,
          581.544,
          898.884,
          697.41
        ],
        "align": "center",
        "tracking": 30.0,
        "caps": 0,
        "maxWidth": 426.42,
        "maxLength": 48
      },
      {
        "key": "date",
        "label": "Date",
        "value": "11.15.2026",
        "prefix": "",
        "font": "Playfair Display",
        "fontFile": "PlayfairDisplay-Regular.ttf",
        "fontPostScript": "PlayfairDisplay-Regular",
        "size": 82.38734,
        "transform": [
          0.7288818532818532,
          0.0,
          0.0,
          0.7288818532818532,
          551.5364237223087,
          785.094808022292
        ],
        "bbox": [
          422.87399999999997,
          741.6899999999999,
          680.436,
          794.088
        ],
        "align": "center",
        "tracking": 30.0,
        "caps": 0,
        "maxWidth": 347.71,
        "maxLength": 48
      }
    ],
    "fixedText": [],
    "staticLayers": [
      {
        "key": "fixed2",
        "label": "&",
        "asset": "mr-layer-124-2-v2.webp",
        "bbox": [
          511.43399999999997,
          628.776,
          550.548,
          670.842
        ]
      }
    ]
  },
  {
    "key": "nk125",
    "sku": "NK-125",
    "name": "Mr & Mrs Family Name",
    "category": "wedding",
    "description": "Mr & Mrs Family Name. Original PSD layout; personalize the text.",
    "canvasSize": 1476,
    "version": "psd1476-20261101",
    "thumbnail": "mr-nk125-white-v2.webp",
    "fixedTexture": "mr-fixed-125-v2.webp",
    "fields": [
      {
        "key": "familyName",
        "label": "Family name",
        "value": "Matthew",
        "prefix": "",
        "font": "Big Caslon",
        "fontFile": "BigCaslon-Web.ttf",
        "fontPostScript": "BigCaslon-Medium",
        "size": 120.0,
        "transform": [
          0.6101881737670393,
          0.0,
          0.0,
          0.6106668262254171,
          489.27045129432565,
          947.3258640926641
        ],
        "bbox": [
          257.562,
          893.718,
          725.454,
          948.33
        ],
        "align": "center",
        "tracking": 100.0,
        "caps": 2,
        "maxWidth": 631.65,
        "maxLength": 48
      },
      {
        "key": "date",
        "label": "Date",
        "value": "11.12.2026",
        "prefix": "",
        "font": "Big Caslon",
        "fontFile": "BigCaslon-Web.ttf",
        "fontPostScript": "BigCaslon-Medium",
        "size": 120.0,
        "transform": [
          0.6101881737670393,
          0.0,
          0.0,
          0.6106668262254171,
          430.23102117849544,
          1050.0982054054052
        ],
        "bbox": [
          260.514,
          996.3,
          600.732,
          1050.912
        ],
        "align": "center",
        "tracking": 100.0,
        "caps": 2,
        "maxWidth": 459.29,
        "maxLength": 48
      }
    ],
    "fixedText": [],
    "staticLayers": [
      {
        "key": "fixed0",
        "label": "Rings",
        "asset": "mr-layer-125-0-v2.webp",
        "bbox": [
          738.7379999999999,
          388.188,
          949.068,
          595.566
        ]
      },
      {
        "key": "fixed1",
        "label": "Mr",
        "asset": "mr-layer-125-1-v2.webp",
        "bbox": [
          258.3,
          315.126,
          675.27,
          563.0939999999999
        ]
      },
      {
        "key": "fixed2",
        "label": "&",
        "asset": "mr-layer-125-2-v2.webp",
        "bbox": [
          257.562,
          628.038,
          369.0,
          811.062
        ]
      },
      {
        "key": "fixed3",
        "label": "Mrs",
        "asset": "mr-layer-125-3-v2.webp",
        "bbox": [
          432.468,
          594.828,
          952.02,
          844.2719999999999
        ]
      }
    ]
  },
  {
    "key": "nk126",
    "sku": "NK-126",
    "name": "Couple Names · Formal",
    "category": "wedding",
    "description": "Couple Names · Formal. Original PSD layout; personalize the text.",
    "canvasSize": 1476,
    "version": "psd1476-20261101",
    "thumbnail": "mr-nk126-white-v2.webp",
    "fixedTexture": "mr-fixed-126-v2.webp",
    "fields": [
      {
        "key": "name1",
        "label": "First name",
        "value": "Cinderalla",
        "prefix": "",
        "font": "Burgues Script",
        "fontFile": "BurguesScript.otf",
        "fontPostScript": "BurguesScript",
        "size": 200.0,
        "transform": [
          0.7288818532818532,
          0.0,
          0.0,
          0.7288818532818532,
          545.8348262793995,
          557.8242695887138
        ],
        "bbox": [
          132.102,
          447.228,
          978.588,
          622.134
        ],
        "align": "center",
        "tracking": 0.0,
        "caps": 0,
        "maxWidth": 1142.76,
        "maxLength": 48
      },
      {
        "key": "name2",
        "label": "Second name",
        "value": "Raymond",
        "prefix": "",
        "font": "Burgues Script",
        "fontFile": "BurguesScript.otf",
        "fontPostScript": "BurguesScript",
        "size": 200.0,
        "transform": [
          0.7288818532818532,
          0.0,
          0.0,
          0.7288818532818532,
          690.3130738183355,
          762.8444314012634
        ],
        "bbox": [
          351.288,
          621.396,
          1040.58,
          852.39
        ],
        "align": "center",
        "tracking": 0.0,
        "caps": 0,
        "maxWidth": 930.54,
        "maxLength": 48
      },
      {
        "key": "date",
        "label": "Date",
        "value": "10.21.2026",
        "prefix": "",
        "font": "Angely Blooming Serif",
        "fontFile": "AngelyBloomingSerif.otf",
        "fontPostScript": "AngelyBloomingSerif-Regular",
        "size": 80.0,
        "transform": [
          0.7288818532818532,
          0.0,
          0.0,
          0.7288818532818532,
          888.4992778685404,
          921.9776329198022
        ],
        "bbox": [
          738.7379999999999,
          878.958,
          1038.366,
          922.5
        ],
        "align": "center",
        "tracking": 100.0,
        "caps": 0,
        "maxWidth": 404.5,
        "maxLength": 48
      }
    ],
    "fixedText": [],
    "staticLayers": [
      {
        "key": "fixed3",
        "label": "&",
        "asset": "mr-layer-126-3-v2.webp",
        "bbox": [
          272.322,
          708.48,
          329.14799999999997,
          766.782
        ]
      }
    ]
  }
]);
